export default "__VITE_ASSET__hiqN53F4__"